import { LoadingSpinner } from 'eezy-components'
import FullWidthLayoutWrapper from 'layouts/full-width/FullWidthLayoutWrapper'
import React, { useEffect, useRef } from 'react'
import { AuthStore } from 'stores'
import { setAuthToken } from 'util/auth/cookies'
import { useInstance } from 'util/di'

import { usePostApiV1SessionRefresh } from 'api'

const SessionRefresher: React.FC = () => {
  const { setSession, setRefreshAttempted } =
    useInstance<AuthStore>('AuthStore')

  // Authenticated solely by the httpOnly remember cookie, which rides along on fetch's
  // default same-origin credentials.
  const { mutate: refreshSession } = usePostApiV1SessionRefresh({})

  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) {
      return
    }
    fired.current = true

    refreshSession()
      .then(session => {
        if (!session?.api_token) {
          setRefreshAttempted(true)
          return
        }

        setAuthToken(session.api_token)
        setSession(session)
      })
      .catch(() => setRefreshAttempted(true))
  }, [refreshSession, setSession, setRefreshAttempted])

  return (
    <FullWidthLayoutWrapper>
      <LoadingSpinner />
    </FullWidthLayoutWrapper>
  )
}

export default SessionRefresher
